import SignatureFieldBase from './SignatureFieldBase';

export default SignatureFieldBase({ isValidated: true });
